﻿import findClosestScrollContainer from "./findClosestScrollContainer.js";

export default (id, scrollVerticallyOnly) => {
    const element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({behavior: "instant", block: "start", inline: "start"});
        if (scrollVerticallyOnly) {
            const scrollContainer = findClosestScrollContainer(element);
            if (scrollContainer) {
                scrollContainer.scrollTo({left: 0});
            }
        }
    }

    return !!element;
};
